import Component, { LOYALTY_TOOLTIP_NAMES } from '../../../../../pages/vip/features/tooltips/loyalty-tooltip';

export default Component;

export { LOYALTY_TOOLTIP_NAMES };
